document.addEventListener('DOMContentLoaded', function() {
  console.log('org-script.js is loaded');

  // ページ全体のクリックを検知（イベント委譲）
  document.addEventListener('click', function(event) {
    // '.mega-menu__link' クラスがついた要素またはその子要素がクリックされたか判定
    const target = event.target.closest('.mega-menu__link');
    
    if (target) {
      // リンク内のテキストを取得（改行や無駄なスペースを除去）
      const linkText = target.textContent.trim();
      // 遷移先URLを取得
      const linkUrl = target.getAttribute('href') || '';

      // GA4のgtagが存在する場合のみ送信
      if (typeof gtag === 'function') {
        gtag('event', 'click_menu_link', {
          'link_text': linkText,
          'link_url': linkUrl
        });
        console.log('GA4 Event Sent: mega_menu_click', { linkText, linkUrl }); // テスト用ログ
      }
    }
  });
});